module.exports = __webpack_public_path__ + "img/orden-b.05ff25a8.svg";